import methods from './methods'
import keys from './keys'

const changeCase = {
  methods,
  keys,
}

export default changeCase
